import React from "react";
import { FaTimes } from "react-icons/fa";
import { getDishDisplayName } from "../utils/dishDisplay";
import { publicRequest } from "../requestMethods";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MosqueModal = ({ mosque, onClose }) => {
  if (!mosque) return null;

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="mosque-modal-overlay">
      <div className="mosque-modal">
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <h2>{mosque.name}</h2>

        {/* Image Album Carousel */}
        {mosque.images?.length > 0 ? (
          <Slider {...sliderSettings}>
            {mosque.images.map((img, index) => (
              <div key={index}>
                <img src={img} alt={`Mosque ${index + 1}`} className="mosque-image" />
              </div>
            ))}
          </Slider>
        ) : (
          <p>No images available</p>
        )}

        {/* Mosque Details */}
        <p><strong>Location:</strong> {mosque.district}, {mosque.state}</p>
        <p><strong>Dish:</strong> {getDishDisplayName(mosque.dish)}</p>
        <p><strong>About:</strong> {mosque.description}</p>

        {/* Open Google Maps */}
        <button className="maps-btn" onClick={() => {
          if (mosque.mosqueID) {
            const user = JSON.parse(localStorage.getItem('user'));
            publicRequest.post(`/mosques/record-directions/${mosque.mosqueID}`, {
              user: user ? { name: user.name, email: user.email, googleId: user.googleId || user.sub, picture: user.picture } : null
            }).catch(() => {});
          }
          window.open(mosque.googleMapsLink, "_blank");
        }}>
          View on Google Maps
        </button>
      </div>
    </div>
  );
};

export default MosqueModal;
